export default "__VITE_ASSET__Bg55GK3B__"